// Customer-facing order status helpers.
//
// Internal Matax Books order statuses map to friendlier customer wording:
//   pending    -> "Pending"          (invoice not finalized yet)
//   PrintReady -> "Processing"        (admin finalizing prices, not payable)
//   Processing -> "Preparing Order"   (printed & sent, invoice live/payable)
//   Completed  -> "Completed"
//   cancelled  -> "Cancelled"
//
// The website /orders API also returns a `status_label`; we prefer it when
// present and otherwise compute from the raw status so screens fed by other
// endpoints (e.g. the parent dashboard summary) stay consistent.

const STATUS_LABELS = {
    pending: 'Pending',
    printready: 'Processing',
    processing: 'Preparing Order',
    completed: 'Completed',
    cancelled: 'Cancelled',
};

const _statusKey = (status) => String(status || 'pending').toLowerCase();

export const customerStatusLabel = (orderOrStatus) => {
    if (orderOrStatus && typeof orderOrStatus === 'object') {
        if (orderOrStatus.status_label) return orderOrStatus.status_label;
        return customerStatusLabel(orderOrStatus.status);
    }
    const key = _statusKey(orderOrStatus);
    return STATUS_LABELS[key] || (orderOrStatus ? String(orderOrStatus) : 'Pending');
};

// MUI Chip `color` for OrderPage.
export const customerStatusChipColor = (status) => {
    switch (_statusKey(status)) {
        case 'completed':
            return 'success';
        case 'processing':   // "Preparing Order"
            return 'primary';
        case 'printready':   // "Processing"
            return 'info';
        case 'pending':
            return 'warning';
        case 'cancelled':
            return 'error';
        default:
            return 'default';
    }
};

// The invoice is finalized (prices visible, invoice viewable/payable) only once
// it has been printed & sent. `pending` and `printready` are pre-finalization.
export const isInvoiceFinalized = (status) => {
    const s = _statusKey(status);
    return s !== 'pending' && s !== 'printready';
};
